import { Box, Center } from '@chakra-ui/react';
import { useDetailedStatusListingDataSuggestions, useApproveListingDataSuggestion, useRejectListingDataSuggestion } from 'hooks/queries/useListingDataSuggestions';
import { ProcessStatus } from 'models/types';
import Slider from 'components/Slider/Slider';
import ListingDataSuggestionCard from 'components/Listing/ListingDataSuggestionCard/ListingDataSuggestionCard';
import Loader from 'components/Loader/Loader';
import EmptyState from 'components/EmptyState/EmptyState';

export default function PendingDataSuggestionsCarousel() {
  const { data: paginatedSuggestions, isLoading } = useDetailedStatusListingDataSuggestions(ProcessStatus.PENDING);
  const approveMutation = useApproveListingDataSuggestion();
  const rejectMutation = useRejectListingDataSuggestion();

  const handleApprove = (suggestionId: string) => {
    approveMutation.mutate({ listing_data_suggestion_id: suggestionId });
  };

  const handleReject = (suggestionId: string) => {
    rejectMutation.mutate({ listing_data_suggestion_id: suggestionId });
  };

  const isActionLoading = approveMutation.isPending || rejectMutation.isPending;

  if (isLoading) {
    return (
      <Center p={8}>
        <Loader />
      </Center>
    );
  }

  if (!paginatedSuggestions?.hasData()) {
    return (
      <Box width="100%">
        <EmptyState
          header="No Pending Data Suggestions"
          description="There are no pending listing data suggestions at this time"
          showButton={false}
        />
      </Box>
    );
  }

  // Get up to 5 suggestions for the carousel
  const suggestions = paginatedSuggestions.data.slice(0, 5);

  const carouselContent = suggestions.map((suggestion, index) => (
    <Box key={`pending_data_suggestion_${suggestion.id}_${index}`} px={2}>
      <ListingDataSuggestionCard
        suggestion={suggestion}
        onApprove={handleApprove}
        onReject={handleReject}
        isLoading={isActionLoading}
        compact={true}
      />
    </Box>
  ));

  return (
    <Box width="100%">
      <Slider
        content={carouselContent}
        slidesPerView={1}
        slidesPerMobileView={1}
        pagination={true}
        enableAutoPlay={false}
        itemPadding={0}
      />
    </Box>
  );
}
